import { Controller } from "@hotwired/stimulus"

import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default class extends Controller {
  connect(){
    const controlsDiv = this.element.parentElement.querySelector(".swiper-controls");
    
    const swiper = new Swiper(this.element, {
      modules: [Navigation, Pagination],
      loop: true,
      speed: 400,
      spaceBetween: 0,
      pagination: {
        el: controlsDiv.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: controlsDiv.querySelector(".swiper-button-next"),
        prevEl: controlsDiv.querySelector(".swiper-button-prev"),
      },
    });
  }

}
